<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Uwagi</div>
            <div class="text-md text-secondary">Domyślnie uzupełniaj pole na uwagi</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-form-field subscriptSizing="dynamic" class="w-full">
            <textarea type="text" rows="4" matInput [formControl]="control" (change)="saveChanges()"></textarea>
        </mat-form-field>
    </div>
</div>
